import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { ReservationService } from '../services/reservation.service';

export const reservationGuard: CanActivateFn = () => {
  // MOCK: Temporalmente permitimos el acceso directo a la ruta para facilitar el desarrollo
  return true;

  /*
  const router = inject(Router);
  const reservationService = inject(ReservationService);

  const hasJourney =
    !!reservationService.selectedOutwardJourney() || !!reservationService.selectedReturnJourney();
  const hasFare = reservationService.selectedFares().length > 0;

  if (hasJourney && hasFare) {
    return true;
  }

  return router.parseUrl('/main');
  */
};
